import { render, staticRenderFns } from "./Pricegroup.vue?vue&type=template&id=0d6d8668&scoped=true"
import script from "./Pricegroup.vue?vue&type=script&lang=js"
export * from "./Pricegroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6d8668",
  null
  
)

export default component.exports